import { FiCalendar, FiCreditCard } from "react-icons/fi";
import { PaymentDetailsInterface } from "./PaymentDetailsInterface";
import { useAuth } from "../../context/AuthContext";
import { dictionary } from "../../utils/dictionary";
import { formatDateInZone, formatCurrency, getCurrencySymbol } from "../../utils/formatters";

export const PaymentDetailsCard = ({ paymentDetails }: { paymentDetails: PaymentDetailsInterface }) => {
  const { language, timezone, country } = useAuth();
  const currencySymbol = getCurrencySymbol(country);

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-4">{dictionary["payment-details"][language]}</h2>
      
      <div className="space-y-3">
        {/* Subtotal */}
        <div className="flex justify-between">
          <span className="text-gray-600">{dictionary["subtotal"][language]}</span>
          <span className="font-medium">{formatCurrency(paymentDetails.subtotal, currencySymbol)}</span>
        </div>
        
        {/* Total - with a divider and bolder text */}
        <div className="flex justify-between pt-3 border-t border-gray-200">
          <span className="font-medium">{dictionary["total"][language]}</span>
          <span className="font-semibold">{formatCurrency(paymentDetails.total, currencySymbol)}</span>
        </div>
        
        {/* Payment method */}
        {paymentDetails?.paymentMethod && (
        <div className="flex items-center gap-2 pt-3 text-sm text-gray-600">
          <FiCreditCard className="text-gray-400" />
          <span>{dictionary["paid-with"][language]} {paymentDetails?.paymentMethod}</span>
          </div>
        )}
        
        {/* Payment date */}
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <FiCalendar className="text-gray-400" />
          <span>{dictionary["paid-on"][language]} {formatDateInZone(paymentDetails.paymentDate, timezone)}</span>
        </div>
      </div>
    </div>
  );
}; 